import { Navigation, Clock, MapPin } from 'lucide-react';

interface DirectionsCardProps {
  data: {
    origin?: string;
    destination?: string;
    distance?: string;
    duration?: string;
    eta?: string;
    end_address?: string;
    lat?: number;
    lng?: number;
    landmark_name?: string;
  };
}

export default function DirectionsCard({ data }: DirectionsCardProps) {
  const mapsUrl = data.lat && data.lng
    ? `https://maps.apple.com/?daddr=${data.lat},${data.lng}`
    : data.end_address
    ? `https://maps.apple.com/?daddr=${encodeURIComponent(data.end_address)}`
    : null;

  return (
    <div className="my-2 border border-cyan-500/30 bg-[#0a1628]/80 backdrop-blur-sm p-3 max-w-[340px]"
         style={{ clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))' }}>
      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        <Navigation className="w-4 h-4 text-cyan-400" />
        <span className="text-cyan-300 font-semibold text-sm">Directions</span>
      </div>

      {/* Destination */}
      <div className="mb-2">
        <div className="text-white text-sm font-medium">
          {data.landmark_name || data.destination || data.end_address || 'Destination'}
        </div>
        {data.end_address && data.landmark_name && (
          <div className="text-gray-400 text-xs mt-0.5">{data.end_address}</div>
        )}
      </div>

      {/* Stats */}
      <div className="flex gap-4 mb-2">
        {data.distance && (
          <div className="flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 text-purple-400" />
            <span className="text-gray-300 text-xs font-mono">{data.distance}</span>
          </div>
        )}
        {data.duration && (
          <div className="flex items-center gap-1.5">
            <Clock className="w-3.5 h-3.5 text-purple-400" />
            <span className="text-gray-300 text-xs font-mono">{data.duration}</span>
          </div>
        )}
      </div>

      {data.eta && (
        <div className="text-gray-400 text-xs">
          ETA: <span className="text-cyan-300 font-mono">{data.eta}</span>
        </div>
      )}

      {/* Open in ATLAS */}
      {mapsUrl && (
        <a
          href={mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 block text-center text-xs py-1.5 border border-cyan-500/30 text-cyan-400 hover:bg-cyan-500/10 transition-colors"
          style={{ clipPath: 'polygon(0 0, calc(100% - 6px) 0, 100% 6px, 100% 100%, 6px 100%, 0 calc(100% - 6px))' }}
        >
          Open in ATLAS
        </a>
      )}
    </div>
  );
}
